var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniCafe01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.886719,
    y: 0.453125,
    width: 258,
    height: 252,
    fill: "#D6895E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_500_11522",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.886719,
    y: 0.453125,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_500_11522)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 191.985,
    cy: 135.351,
    r: 98.6899,
    transform: "rotate(-12.0382 191.985 135.351)",
    fill: "#232444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.368,
    cy: 122.123,
    r: 90.5609,
    transform: "rotate(-12.0382 199.368 122.123)",
    fill: "#686CD3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.369,
    cy: 122.121,
    r: 86.3732,
    transform: "rotate(-12.0382 199.369 122.121)",
    fill: "#EBECFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.369,
    cy: 122.12,
    r: 84.2793,
    transform: "rotate(-12.0382 199.369 122.12)",
    fill: "#D97B5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.157 157.485L146.622 108.205L166.847 130.568L249.861 153.082L223.212 210.082C216.686 211.713 209.879 212.651 202.871 212.813C164.276 213.704 130.673 190.78 116.157 157.485Z",
    fill: "#1E1F2F",
    fillOpacity: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.312,
    cy: 125.493,
    r: 50.2535,
    transform: "rotate(-15.7648 199.312 125.493)",
    fill: "#686CD3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.484 173.144C243.029 165.368 259.055 136.734 251.279 109.189C243.502 81.6442 214.869 65.6184 187.324 73.3946C162.527 80.395 147.066 104.299 149.901 129.094C151.603 156.023 174.532 176.781 201.626 175.663C206.216 175.474 210.635 174.668 214.807 173.33C215.033 173.27 215.258 173.207 215.484 173.144ZM214.807 173.33C235.598 166.661 250.248 146.755 249.304 123.88C248.17 96.4143 224.986 75.0682 197.521 76.2019C170.055 77.3356 148.709 100.52 149.843 127.985C149.858 128.356 149.877 128.726 149.901 129.094C150.215 131.842 150.754 134.601 151.53 137.349C159.242 164.668 187.471 180.656 214.807 173.33Z",
    fill: "#333679"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.282 177.782C247.708 169.193 265.411 137.564 256.821 107.137C248.231 76.71 216.602 59.0076 186.175 67.5973C155.749 76.1871 138.046 107.816 146.636 138.243C155.226 168.67 186.855 186.372 217.282 177.782ZM215.497 171.458C242.432 163.854 258.103 135.854 250.499 108.919C242.895 81.984 214.896 66.313 187.96 73.917C161.025 81.521 145.354 109.52 152.958 136.456C160.562 163.391 188.562 179.062 215.497 171.458Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.007,
    y: 104.367,
    width: 23.0328,
    height: 9.42253,
    rx: 4.71126,
    transform: "rotate(-15.7648 251.007 104.367)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.555 242.453V222.656H190.32C194.818 222.656 197.402 225.432 197.402 229.328C197.402 233.279 194.777 236 190.211 236H186.656V242.453H182.555ZM186.656 232.691H189.555C191.988 232.691 193.178 231.324 193.164 229.328C193.178 227.359 191.988 226.033 189.555 226.02H186.656V232.691ZM201.367 242.699C200.082 242.699 199.043 241.674 199.07 240.402C199.043 239.145 200.082 238.119 201.367 238.133C202.584 238.119 203.637 239.145 203.637 240.402C203.637 241.674 202.584 242.699 201.367 242.699ZM206.973 242.453V222.656H214.738C219.236 222.656 221.82 225.432 221.82 229.328C221.82 233.279 219.195 236 214.629 236H211.074V242.453H206.973ZM211.074 232.691H213.973C216.406 232.691 217.596 231.324 217.582 229.328C217.596 227.359 216.406 226.033 213.973 226.02H211.074V232.691ZM228.383 222.656V242.453H224.336V222.656H228.383ZM238.254 242.754C233.701 242.74 230.912 239.801 230.926 235.098C230.912 230.518 233.742 227.414 238.09 227.414C241.986 227.414 245.062 229.875 245.062 234.934V236.082H234.918C234.918 238.324 236.244 239.705 238.336 239.719C239.717 239.705 240.701 239.104 241.098 238.215H244.953C244.379 240.963 241.918 242.74 238.254 242.754ZM234.918 233.539H241.234C241.221 231.734 239.977 230.436 238.172 230.449C236.312 230.436 235 231.83 234.918 233.539Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniCafe01);
export default __webpack_public_path__ + "static/media/mini_cafe_01.d01135f3a7d4f40a368cbdd26767660d.svg";
export { ForwardRef as ReactComponent };